import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { withProps } from 'recompose';
import { scrollBarWidth } from '../../utils/scrollBarWidth';

import './index.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
  inSlider?: boolean;
}

type ScrollBarWidth = { scrollBarWidth: number };

const b = b_.with('modal');

const enhance = withProps<ScrollBarWidth, Props>(() => ({ scrollBarWidth }));

interface State {
  closing: boolean;
}

export class Modal extends React.Component<ScrollBarWidth & Props, State> {
  private modal: HTMLDivElement | null = null;

  state: State = {
    closing: false,
  };

  render() {
    const { children, className, inSlider, ...props } = this.props;
    const { closing } = this.state;

    return (
      <div className={b({ slider: inSlider })}>
        <div
          className={b('container', { enter: !closing, leave: closing })}
          onClick={this.onBackgroundClick}
        >
          <div
            className={cn(b('content', { enter: !closing, leave: closing }), className)}
            ref={(el) => (this.modal = el)}
            {...props}
          >
            {children}
            <span
              className={`${b('close')} rodal-close`}
              onClick={this.hide}
              data-testid="close-btn"
            />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (typeof window === 'undefined') {
      return;
    }
    this.toggleBodyClass(true);
    window.addEventListener('keydown', this.closeOnEsc);
  }

  componentWillUnmount() {
    if (typeof window === 'undefined') {
      return;
    }
    this.toggleBodyClass(false);
    window.removeEventListener('keydown', this.closeOnEsc);
  }

  private toggleBodyClass(toggle: boolean) {
    const className = b('overflow-hidden');
    const { body } = window.document;
    if (toggle !== body.classList.contains(className)) {
      body.classList[toggle ? 'add' : 'remove'](className);
      body.style.paddingRight = !toggle ? '0' : `${scrollBarWidth}px`;
    }
  }

  private closeOnEsc = (e: KeyboardEvent) => {
    if (e.keyCode !== 27) {
      return;
    }
    this.hide();
  };

  private onBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!this.modal || this.modal.contains(e.target as Node)) {
      return;
    }
    this.hide();
  };

  private hide = () => {
    this.setState({ closing: true }, () => setTimeout(() => this.props.onClose(), 100));
  };
}

export default enhance(Modal);
